var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 3.54175C10.3455 3.54175 10.6253 3.82157 10.6253 4.16675V9.37507H15.8337C16.1788 9.37507 16.4587 9.65489 16.4587 10.0001C16.4587 10.3452 16.1788 10.6251 15.8337 10.6251H10.6253V15.8334C10.6253 16.1786 10.3455 16.4584 10.0003 16.4584C9.65513 16.4584 9.37531 16.1786 9.37531 15.8334V10.6251H4.16699C3.82181 10.6251 3.54199 10.3452 3.54199 10.0001C3.54199 9.65489 3.82181 9.37507 4.16699 9.37507H9.37531V4.16675C9.37531 3.82157 9.65513 3.54175 10.0003 3.54175Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhite);
export default __webpack_public_path__ + "static/media/plusWhite.1d5d95f25bca547983e3498bb1954408.svg";
export { ForwardRef as ReactComponent };